/* src/app/conciliadora-main/registro-detail/registro-detail.component.scss */
.registro-detail {
  padding: 0 4px;
}
.detail-status-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}
.detail-status-header .status-tag-large {
  font-size: 13px;
  padding: 2px 10px;
}
.detail-status-header .detail-id {
  font-size: 13px;
  color: #8c8c8c;
  font-weight: 500;
}
.detail-actions {
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
}
.section-descriptions {
  margin-top: 16px;
}
.tipo-config-section {
  margin-top: 8px;
}
/*# sourceMappingURL=registro-detail.component.css.map */
